import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { ScholarshipTypeType } from "../../types/ScholarshipType";
import { del, get, post, put } from "../../utils/axios-config";
import { SCHOLARSHIP_TYPES } from "../../utils/constants";

export const createScholarshipType = async (data: ScholarshipTypeType) => 
    await post(SCHOLARSHIP_TYPES, data);

export const getScholarshipTypes = async (data: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || "1",
        PageSize: data?.PageSize?.toString() || "100",
    });
    return await get<PagedResultsType<ScholarshipTypeType>>(`${SCHOLARSHIP_TYPES}?${queryParams.toString()}`);
};

export const updateScholarshipType = async (data: ScholarshipTypeType) => 
    await put(SCHOLARSHIP_TYPES, data);

// export const deleteScholarshipType = async (id: string) => 
//     await del(`${SCHOLARSHIP_TYPES}/${id}`, {});
